<template>
    <div class="container">
        <div class="modificatorsBox">
            <div
                class="list"
                v-for="addon in addons"
            >
                <h5>{{ addon.title }}</h5>
                <div
                    class="option"
                    v-for="option in addon.options"
                    @click="currentItem.toggleOption(option)"
                    :class="{active: currentItem.activeModifiers[option.id], radio: addon.multiple_max == 1, nobutn: addon.quantity_ability == 1}"
                >
                    <span>{{option.title.toLowerCase()}}</span>
                    <span class="quantityAbility" v-if="addon.quantity_ability == 1">
                        <span class="sign" @click.stop="currentItem.changeOptionCount(-1, option, addon)">
                            <svg width="14" height="2" viewBox="0 0 14 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.336426 1H13.0091" stroke="#D13238" stroke-width="2"/>
                            </svg>
                        </span>
                        <span class="count">{{ option.quantity }}</span>
                        <span class="sign" @click.stop="currentItem.changeOptionCount(+1, option, addon)">
                            <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14.8892 8H8.88916V14H6.88916V8H0.88916V6H6.88916V0H8.88916V6H14.8892V8Z" fill="#CF3339"/>
                            </svg>
                        </span>
                    </span>
                    <span class="ml-auto muli price buttonTextSmall pl-3 pr-md-4"><span v-if="option.cost != '0.00'">${{option.cost}}</span></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Addons",
        created() {
        },
        computed: {
            currentItem() {
                return this.$store.state.menu.currentItem
            },
            addons() {
                return this.$store.state.menu.currentItem.modifiers;
            }
        }
    }
</script>
